import { useTranslation } from "react-i18next";
import "./index.less";

const MediaPushNotifyBanner = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="header-info-name-change-container">
        <span className="header-info-name-change-text white"> {t("media-push-sent-in-progress")}</span>
        <span className="animated-dots header-info-name-change-text white">
          <span className="dot dot-1">.</span>
          <span className="dot dot-2">.</span>
          <span className="dot dot-3">.</span>
        </span>
      </div>
    </>
  );
};

export default MediaPushNotifyBanner;
